import { getBalance } from 'Api/balanceApi'
import { getBonusBalance } from 'Api/bonusApi'
import { parseBonusBalance } from 'Parsers/bonusParser'
import BalanceState from 'Types/_Store/Balance'

const state: BalanceState = {
  isRequesting: false,

  credits: 0,
  amount: 0,

  bonus: {
    current: 0,
    total: 0,
    expirationDate: '',
    renewDate: '',
    unavailable: false,
  },
}

const getters = {
  percentageBalance: state => state.credits * 100 / state.amount
}

const mutations = {
  request_start(state) {
    state.isRequesting = true
  },

  request_success(state) {
    state.isRequesting = false
  },

  request_failure(state) {
    state.isRequesting = false
  },

  set_credits(state, credits) {
    state.credits = credits
  },

  set_amount(state, amount) {
    state.amount = amount
  },

  set_bonus(state, bonus) {
    Object.assign(state.bonus, bonus)
  },
}

const actions = {
  async getBalance({ commit }) {
    commit('request_start')

    try {
      const [ balanceResult, bonusResult ] = await Promise.all([
        getBalance(),
        getBonusBalance()
      ])

      const { amount, amountCredit } = balanceResult.data
      commit('set_amount', amount)
      commit('set_credits', amountCredit)

      const bonus = parseBonusBalance(bonusResult.data)
      commit('set_bonus', bonus)

      commit('request_success')

      return [ balanceResult.data, bonusResult.data ]
    } catch (err) {
      commit('request_failure')

      throw err
    }
  }
}

export default {
  namespaced: true,

  getters,
  state,
  actions,
  mutations
}